import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../global/theme/tokens';
import MoneyLabel from '../../label/MoneyLabel';

const labelMap = {
  '0-30': '0-30 days',
  '31-60': '31-60 days',
  '61-90': '61-90 days',
  '90+': '90+ days',
};

const colorForBucket = (colors, key) => {
  switch (key) {
    case '0-30':
      return colors.success;
    case '31-60':
      return colors.warning;
    case '61-90':
      return colors.colorPool?.[4] ?? colors.warning;
    case '90+':
      return colors.error;
    default:
      return colors.colorPool?.[0];
  }
};

const AgingBuckets = ({ specials }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const buckets = specials?.buckets || [];
  const maxOpen = Math.max(...buckets.map((b) => b.openGross ?? 0), 1);

  return (
    <Box className="flex flex-col gap-1.5">
      <Typography
        variant="caption"
        sx={{ color: colors.text, opacity: 0.7, fontWeight: 500 }}
      >
        {t('Aging')}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 1,
        }}
      >
        {buckets.map((bucket) => {
          const color = colorForBucket(colors, bucket.key);
          const heightPct = ((bucket.openGross ?? 0) / maxOpen) * 100;
          return (
            <Box
              key={bucket.key}
              sx={{
                backgroundColor: colors.card,
                border: `1px solid ${colors.selected}`,
                borderRadius: '8px',
                padding: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 0.5,
              }}
            >
              <Typography
                variant="caption"
                sx={{ color, fontWeight: 600, fontSize: '0.7rem' }}
              >
                {t(labelMap[bucket.key] ?? bucket.label ?? bucket.key)}
              </Typography>
              <Box
                sx={{
                  height: 40,
                  display: 'flex',
                  alignItems: 'flex-end',
                  width: '100%',
                  backgroundColor: colors.bgInput,
                  borderRadius: 4,
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: `${Math.max(2, heightPct)}%`,
                    backgroundColor: color,
                    transition: 'height 0.3s ease',
                  }}
                />
              </Box>
              <Box className="flex justify-between items-center">
                <Typography
                  variant="caption"
                  sx={{ color: colors.text, opacity: 0.7, fontSize: '0.7rem' }}
                >
                  {bucket.count}×
                </Typography>
                <MoneyLabel money={bucket.openGross ?? 0} variant="caption" />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default AgingBuckets;
